<template>
  <div class="app-main-content">
    <cargo-up-down-resize
      class="main-content"
      :up-style="{display: 'flex', flexDirection: 'column', paddingBottom: '5px', height:'60%'}"
      :down-style="{display: 'flex', flexDirection: 'column',paddingTop:'5px', height:'40%'}"
      style="height: 100%"
    >

      <template slot="up">
        <div class="section" style="flex: 1">
          <div style="padding-bottom: 8px;">
            <el-form :inline="true" label-width="80px" label-position="left">
              <el-form-item label-width="0">
                <el-button no="1" type="primary" @click="upSearchNoPallet()">查询</el-button>
              </el-form-item>
              <el-form-item label="货箱编号">
                <el-select v-model="up.containerNoOpt" no="4" style="width: 60px;" placeholder=" ">
                  <!--                  <el-option label="批量" value="BATCH" />-->
                  <el-option label="等于" value="=" />
                  <el-option label="不等于" value="!=" />
                  <el-option label="包含" value="LIKE" />
                </el-select>
                <el-input v-model="up.containerNo" no="5" style="width:150px;padding-left: 8px;" />
              </el-form-item>
              <el-form-item label="中文品名">
                <el-select v-model="up.cargoNameOpt" no="6" style="width: 60px;" placeholder=" ">
                  <el-option label="等于" value="=" />
                  <el-option label="不等于" value="!=" />
                  <el-option label="包含" value="LIKE" />
                </el-select>
                <el-input v-model="up.cargoName" no="7" style="width:150px;padding-left: 8px;" />
              </el-form-item>
              <el-form-item label="Shipment ID">
                <el-select v-model="up.shipmentIdOpt" no="8" style="width: 60px;" placeholder=" ">
                  <el-option label="等于" value="=" />
                  <el-option label="不等于" value="!=" />
                  <el-option label="包含" value="LIKE" />
                </el-select>
                <el-input v-model="up.shipmentId" no="9" style="width:150px;padding-left: 8px;" />
              </el-form-item>
              <el-form-item label="Ref ID">
                <el-select v-model="up.referenceIdOpt" no="8" style="width: 60px;" placeholder=" ">
                  <el-option label="等于" value="=" />
                  <el-option label="不等于" value="!=" />
                  <el-option label="包含" value="LIKE" />
                </el-select>
                <el-input v-model="up.referenceId" no="9" style="width:150px;padding-left: 8px;" />
              </el-form-item>
            </el-form>
          </div>
          <div style="padding-bottom: 8px;">
            已选中 {{ up.selectedCount }} / {{ upAllCount }}
            <el-button :disabled="!isEdit" no="2" @click="upPick()">拣选</el-button>
            <el-input-number v-model="up.upQuantity" no="3" controls-position="right" :min="0" :precision="0" style="padding-left: 8px;" />件
          </div>
          <cargo-ag-grid
            no="10"
            config-module="140000"
            :grid-options="gridOptions"
            :grid-params.sync="gridParams"
            :column-defs="columnDefs"
            :row-data="upRowData"
            style="width:100%;flex:1"
            @gridReady="params=>gridApi=params.api"
          />
        </div>
        <div style="padding:5px 0">
          <div style="float:left">
            <el-button :disabled="!isEdit" no="11" type="primary" @click="addPallet()">添加托盘</el-button>
            <el-button :disabled="!isEdit" no="12" type="danger" @click="removePallet()">删除托盘</el-button>
            <el-button :disabled="!isEdit" no="13" type="info" plain style="color:green" @click="addToPalletHandler()">↓</el-button>
            <el-button :disabled="!isEdit" no="14" type="info" plain style="color:red" @click="removeToPalletHandler()">↑</el-button>
            <cargo-el-upload
              no="35"
              :disabled="isEdit"
              :action="URL.booking.warehouseInDetail.importExcelPallet"
              :show-file-list="false"
              accept=".xlsx"
              :on-progress="handleProgress"
              :on-success="handleSuccess"
              :on-error="handleError"
              :data="{branchId:$store.getters.currentOfficeId, warehouseInUuid:warehouseIn.uuid}"
              style="display: inline-block; padding-left: 5px; padding-right: 5px;"
            >
              <el-button :disabled="isEdit" no="15" type="primary">EXCEL导入</el-button>
            </cargo-el-upload>
            <el-button :disabled="isEdit" no="16" type="primary" @click="downLoad()">导入模板下载</el-button>
          </div>
          <div style="float:right">
            <el-form :inline="true" label-width="55px" label-position="left">
              <el-form-item :label="totalLabel.package" class="custom">
                <el-input v-model="up.totalQuantity" no="17" style="width:100px" />
              </el-form-item>
              <el-form-item :label="totalLabel.weight" class="custom">
                <el-input v-model="up.totalWeight" no="18" style="width:100px" />
              </el-form-item>
              <el-form-item :label="totalLabel.cubage" class="custom">
                <el-input v-model="up.totalCubage" no="19" style="width:100px" />
              </el-form-item>
            </el-form>
          </div>
        </div>
      </template>

      <template
        slot="down"
      >
        <cargo-left-right-resize
          :left-style="{display: 'flex', flexDirection: 'column',width:'26%'}"
          :right-style="{display: 'flex', flexDirection: 'column',width:'74%'}"
          style="height: 100%;min-height: 300px"
        >
          <template
            slot="left"
          >
            <div class="section" style="flex: 1">
              <div style="padding-bottom: 8px;">
                <el-button no="1" type="primary" style="margin-right: 8px;" @click="downSearchPallet()">查询</el-button>
                <el-input v-model="down.cargoName" no="20" style="width:200px;" placeholder="根据中文品名过滤托盘" />
              </div>
              <cargo-ag-grid
                no="21"
                config-module="140001"
                :grid-options="left.gridOptions"
                :grid-params.sync="left.gridParams"
                :column-defs="downLeftColumnDefs"
                :row-data="downLeftRowData"
                style="height:100%"
                @gridReady="params=>left.gridApi=params.api"
              />
            </div>
          </template>
          <template
            slot="right"
          >
            <div class="section" style="flex: 1;">
              <div style="padding-bottom: 8px;">
                <el-button no="22" type="primary" style="padding-right: 15px;" @click="downSearchCargoDetail()">查询</el-button>
                货箱编号
                <el-select v-model="down.containerNoOpt" no="23" style="width: 60px;" placeholder=" ">
                  <!--                  <el-option label="批量" value="BATCH" />-->
                  <el-option label="等于" value="=" />
                  <el-option label="不等于" value="!=" />
                  <el-option label="包含" value="LIKE" />
                </el-select>
                <el-input v-model="down.containerNo" no="24" style="width:200px; padding-left: 8px;" />
              </div>
              <cargo-ag-grid
                no="25"
                config-module="140002"
                :grid-options="right.gridOptions"
                :grid-params.sync="right.gridParams"
                :column-defs="downRightColumnDefs"
                :row-data="downRightRowData || []"
                style="flex-grow:1"
                @gridReady="params=>right.gridApi=params.api"
              />
            </div>
            <div style="padding:5px 0">
              <div style="float:left">
                已选中 {{ down.selectedCount }} / {{ downAllCount }}
              </div>
              <div style="float:right">
                <el-form :inline="true" label-width="55px" label-position="left">
                  <el-form-item :label="totalLabel.package" class="custom">
                    <el-input v-model="down.totalQuantity" no="26" style="width:100px" />
                  </el-form-item>
                  <el-form-item :label="totalLabel.weight" class="custom">
                    <el-input v-model="down.totalWeight" no="27" style="width:100px" />
                  </el-form-item>
                  <el-form-item :label="totalLabel.cubage" class="custom">
                    <el-input v-model="down.totalCubage" no="28" style="width:100px" />
                  </el-form-item>
                </el-form>
              </div>
            </div>
          </template>
        </cargo-left-right-resize>
      </template>
    </cargo-up-down-resize>
  </div>
</template>

<script>

import cargoUpDownResize from '@/components/Cargo/Common/cargoUpDownResize'
import cargoLeftRightResize from '@/components/Cargo/Common/cargoLeftRightResize'
import { getUuid, sortByMultiField } from '@/utils'
import { WarehouseIn } from '@/class/model/booking/WarehouseIn'
import { FbaPallet } from '@/class/model/booking/FbaPallet'
import CargoAgGridCommonInputEditor from '@/components/Cargo/Common/CargoAgGridCommonInputEditor'
import CargoAgGridAdvanceSelectEditor from '@/components/Cargo/Common/CargoAgGridAdvanceSelectEditor'
import CargoAgGridColumnEditGroup from '@/components/Cargo/Common/CargoAgGridColumnEditGroup'
import { ExportUtils } from '@/class/cargo/model/utils/ExportUtils'
import CargoElUpload from '@/components/Cargo/Common/cargoElUpload'
import { getLoading } from '@/utils/utilBaseElement'
import URL from '@/api/urlTranslator'
import { cache, cacheName } from '@/utils/cacheManager'
import { TabError } from '@/utils/class/TabError'
import lang from '@/lang'
import * as NumberUtils from '@/utils/NumberUtils'

export default {
  name: 'FbaPallet',
  components: { CargoElUpload, cargoUpDownResize, cargoLeftRightResize },
  props: {
    context: {
      type: Object,
      required: true
    },
    action: {
      type: String,
      required: true
    }
  },
  data() {
    return {
      URL,
      gridParams: {},
      gridOptions: {
        rowSelection: 'multiple',
        suppressCellSelection: true, // 如果为true，则不能选择单元格。这意味着当您单击它们时，单元格不会获得键盘焦点。
        suppressRowClickSelection: true, // 如果为true， 则单击行时不会发生行选择。当您想要专门选择复选框时使用。
        context: {
          componentParent: this
        },
        onSelectionChanged: (event) => {
          this.onUpSelectionChanged(event)
        }
      },
      columnDefs: [
        {
          headerName: '',
          field: '',
          width: 40,
          headerCheckboxSelection: true,
          checkboxSelection: true,
          sortable: false,
          suppressMenu: true,
          suppressSizeToFit: true,
          resizable: false
        },
        // {
        //   headerName: '序号',
        //   field: 'sequenceNo',
        //   width: 65
        // },
        {
          headerName: '货箱编号',
          field: 'containerNo',
          width: 150
        },
        {
          headerName: 'Shipment Id',
          field: 'shipmentId',
          width: 150
        },
        {
          headerName: 'Ref ID',
          field: 'referenceId',
          width: 150
        },
        {
          headerName: '中文品名',
          field: 'cargoChineseName',
          width: 150
        },
        {
          headerName: '货物箱重量',
          field: 'singleBoxWeight',
          width: 150
        },
        {
          headerName: '货物箱长度cm',
          field: 'boxLength',
          width: 150
        },
        {
          headerName: '货物箱宽度cm',
          field: 'boxWidth',
          width: 150
        },
        {
          headerName: '货物箱高度cm',
          field: 'boxHeight',
          width: 150
        },
        {
          headerName: '商品数量',
          field: 'quantity',
          width: 150
        }
      ],
      gridApi: null,
      left: {
        gridParams: {},
        gridOptions: {
          rowSelection: 'multiple',
          singleClickEdit: true,
          suppressCellSelection: true, // 如果为true，则不能选择单元格。这意味着当您单击它们时，单元格不会获得键盘焦点。
          suppressRowClickSelection: true, // 如果为true， 则单击行时不会发生行选择。当您想要专门选择复选框时使用。
          context: {
            componentParent: this
          },
          frameworkComponents: {
            CargoAgGridCommonInputEditor,
            CargoAgGridAdvanceSelectEditor,
            CargoAgGridColumnEditGroup
          },
          onRowClicked: this.palletChangeHandler
        },
        gridApi: null,
        uuidPrefixRule: 'FbaPallet'
      },
      right: {
        gridParams: {},
        gridOptions: {
          rowSelection: 'multiple',
          suppressCellSelection: true,
          suppressRowSelection: true,
          suppressRowClickSelection: false,
          rowMultiSelectWithClick: false,
          context: {
            componentParent: this
          },
          onSelectionChanged: (event) => {
            this.onDownSelectionChanged(event)
          }
        },
        gridApi: null
      },
      up: {
        selectedCount: 0, // 选中
        totalQuantity: '',
        totalWeight: '',
        totalCubage: '',
        upQuantity: 0, // 拣选后面的件数
        containerNo: '', // 货箱编号
        cargoName: '', // 中文品名
        shipmentId: '', // shipment Id
        containerNoOpt: '=', // 货箱编号 操作符
        cargoNameOpt: '=', // 中文品名 操作符
        shipmentIdOpt: '=', // shipment Id 操作符
        referenceId: '', // referenceId 操作符
        referenceIdOpt: '=' // referenceId 操作符
      },
      down: {
        selectedCount: 0, // 选中
        totalQuantity: '',
        totalWeight: '',
        totalCubage: '',
        cargoName: '', // 中文品名
        cargoNameOpt: '=', // 中文品名 操作符
        containerNo: '', // 货箱编号
        containerNoOpt: '=' // 货箱编号 操作符
      },
      totalLabel: { // 合计汇总label
        package: this.$t('SeaExport.TotalNumberOfPackages') + ':',
        weight: this.$t('SeaExport.TotalWeight') + ':',
        cubage: this.$t('SeaExport.TotalCubage') + ':'
      },
      downLeftRowData: [], // 托盘信息
      selectedPallet: { warehouseInDetailList: [] }, // 选中的托盘信息
      delFbaPalletKeys: [], // 删除托盘信息
      removeCargoDetails: [], // 移除托盘关系的货物信息
      warehouseIn: new WarehouseIn().fillDefaultValue().getData() // 选中的箱子
    }
  },
  computed: {
    readonly() {
      return this.action === 'look'
    },
    isEdit() {
      return this.action !== 'look'
    },
    upRowData() { // 未打托的箱货信息【过滤掉已经打托和已出库的箱货信息】
      return this.warehouseIn && this.warehouseIn.warehouseInDetailList ? this.warehouseIn.warehouseInDetailList.filter(p => !p.palletUuid && !p.outWarehouseUuid) : []
    },
    downRightRowData() {
      return this.selectedPallet && this.selectedPallet.warehouseInDetailList ? this.selectedPallet.warehouseInDetailList : []
    },
    upAllCount() {
      return this.upRowData.length || 0
    },
    downAllCount() {
      return this.selectedPallet && this.selectedPallet.warehouseInDetailList ? this.selectedPallet.warehouseInDetailList.length : 0
    },
    downLeftColumnDefs() {
      return [
        {
          headerName: '',
          field: '',
          width: 40,
          headerCheckboxSelection: true,
          checkboxSelection: true,
          sortable: false,
          suppressMenu: true,
          suppressSizeToFit: true,
          resizable: false
        },
        {
          headerName: '托盘编号',
          colId: 'palletNo',
          field: 'palletNo',
          width: 100,
          editable: (params) => this.isEdit && this.isEditPallet(params),
          cellEditor: 'CargoAgGridCommonInputEditor',
          onCellValueChanged: (params) => {
            this.onCellChange(params)
          }
        },
        {
          headerName: '货箱数量',
          colId: 'boxesNumber',
          field: 'boxesNumber',
          width: 100,
          editable: (params) => this.isEdit && this.isEditPallet(params),
          cellEditor: 'CargoAgGridCommonInputEditor',
          cellEditorParams: {
            isNumber: true,
            inputProps: {
              precision: 0,
              max: 999999999,
              min: 0,
              controlsPosition: 'right',
              style: 'width: 100%'
            }
          },
          valueFormatter: params => {
            return this.$numeral(params.value).format('0')
          },
          onCellValueChanged: (params) => {
            this.onCellChange(params)
          }
        },
        {
          headerName: '货品',
          colId: 'cargoName',
          field: 'cargoName',
          width: 100,
          editable: (params) => this.isEdit && this.isEditPallet(params),
          cellEditor: 'CargoAgGridCommonInputEditor',
          onCellValueChanged: (params) => {
            this.onCellChange(params)
          }
        },
        {
          headerName: '状态',
          colId: 'status',
          field: 'status',
          width: 100,
          editable: () => false,
          cellEditor: 'CargoAgGridCommonInputEditor',
          valueFormatter: params => {
            return params.value && Number(params.value) === 1 ? '已出库' : ''
          }
        }
      ]
    },
    downRightColumnDefs() {
      return [
        {
          headerName: '',
          field: '',
          width: 40,
          headerCheckboxSelection: true,
          checkboxSelection: true,
          sortable: false,
          suppressMenu: true,
          suppressSizeToFit: true,
          resizable: false
        },
        /* {
          headerName: '序号',
          field: 'sequenceNo',
          colId: 'sequenceNo',
          width: 65
        },*/
        {
          headerName: '货箱编号',
          field: 'containerNo',
          colId: 'containerNo',
          width: 150
        },
        {
          headerName: 'Shipment Id',
          field: 'shipmentId',
          colId: 'shipmentId',
          width: 150
        },
        {
          headerName: '中文品名',
          field: 'cargoChineseName',
          colId: 'cargoChineseName',
          width: 150
        },
        {
          headerName: '货物箱重量',
          field: 'singleBoxWeight',
          colId: 'singleBoxWeight',
          width: 150,
          valueFormatter: params => {
            return this.$numeral(params.value).format('0.000')
          }
        },
        {
          headerName: '货物箱长度cm',
          field: 'boxLength',
          colId: 'boxLength',
          width: 150,
          valueFormatter: params => {
            return this.$numeral(params.value).format('0.000')
          }
        },
        {
          headerName: '货物箱宽度cm',
          field: 'boxWidth',
          colId: 'boxWidth',
          width: 150,
          valueFormatter: params => {
            return this.$numeral(params.value).format('0.000')
          }
        },
        {
          headerName: '货物箱高度cm',
          field: 'boxHeight',
          colId: 'boxHeight',
          width: 150,
          valueFormatter: params => {
            return this.$numeral(params.value).format('0.000')
          }
        },
        {
          headerName: '商品数量',
          field: 'quantity',
          colId: 'quantity',
          width: 150,
          valueFormatter: params => {
            return this.$numeral(params.value).format('0')
          }
        }
      ]
    }
  },
  async created() {
    await cache.load(cacheName.USER, cacheName.CONFIG)
  },
  methods: {
    onShow(row, isRefresh) {
      if (!isRefresh) {
        return
      }
      this.selectedPallet = { warehouseInDetailList: [] } // 切换入库单时需要刷新右下角已经打托的箱子
      this.warehouseIn = row
      const allDetailList = this.warehouseIn.warehouseInDetailList || []
      const allPallets = this.warehouseIn.fbaPallets || []

      // 过滤掉已经打托的箱货信息，未打托的箱货信息
      // this.upRowData = allDetailList.filter(p => !p.palletUuid) || []

      // 将托盘和已打托的箱货信息组装好
      for (const pallet of allPallets) {
        pallet.warehouseInDetailList = []
        if (allDetailList.length <= 0) continue
        for (const detail of allDetailList) {
          if (detail.palletUuid === pallet.uuid) {
            pallet.warehouseInDetailList.push(detail)
          }
        }
      }
      this.downLeftRowData = allPallets
      // 默认选中新增行
      this.$nextTick(() => {
        this.setGridSelectPallet()
        this.calcPallets()
        this.onUpSelectionChanged()
      })
    },
    calcPallets() {
      this.calcUpSumJmt()
      this.calcDownSumJmt()
      if (this.left.gridApi) this.left.gridApi.refreshCells({ force: true })
      if (this.right.gridApi) this.right.gridApi.refreshCells({ force: true })
    },
    // 保存数据提交
    getSubmitData() {
      let fbaPallets = []
      const palletNoMap = new Map()
      if (this.downLeftRowData && this.downLeftRowData.length > 0) {
        fbaPallets = this.downLeftRowData.filter(p => p.isDirty)
        for (const fbaPallet of this.downLeftRowData) {
          if (!fbaPallet.palletNo) {
            throw new TabError('托盘编号未填写，请检查', 'fbaPallet')
          }
          if (palletNoMap.has(fbaPallet.palletNo)) {
            throw new TabError('托盘编号[' + fbaPallet.palletNo + ']重复，请检查', 'fbaPallet')
          }
          palletNoMap.set(fbaPallet.palletNo, fbaPallet.palletNo)
        }
      }
      this.warehouseIn.warehouseInDetail = []
      this.warehouseIn.businessDocument = []
      return {
        fbaWarehouseInVO: this.warehouseIn,
        fbaPallets,
        delFbaPalletKeys: this.delFbaPalletKeys,
        removeCargoDetails: this.removeCargoDetails
      }
    },
    // 托盘信息列编辑修改事件
    onCellChange(params) {
      const pallet = params.data
      if (!pallet) {
        return
      }
      pallet.isDirty = true // 用于校验数据是否修改标识
      // 排序
      // if (params.field === 'serialNo') {
      //   sortByMultiField(this.selectedContainer.containerUsage, ['serialNo'], false)
      // }
      this.left.gridApi.refreshCells({ force: true })
    },
    palletChangeHandler(event) {
      this.selectedPallet = event.data
      this.calcDownSumJmt()
      this.onDownSelectionChanged()
    },
    // 未打托的箱货信息行选中
    onUpSelectionChanged(event) {
      const selectedRows = this.gridApi ? this.gridApi.getSelectedRows() : []
      this.up.selectedCount = selectedRows ? selectedRows.length : 0
    },
    // 已打托的箱货信息行选中
    onDownSelectionChanged(event) {
      const selectedRows = this.right.gridApi.getSelectedRows()
      this.down.selectedCount = selectedRows ? selectedRows.length : 0
    },
    // 组装打印参数
    getPrintData() {
      // if (this.job && this.job.masterFlag) {
      //   const containers = this.left.gridApi.getSelectedRows()
      //   const params = {}
      //   if (containers.length === 0) {
      //     this.$message.warning(this.$t('Message.NoSelectedContainerInformation'))
      //     return
      //   }
      //   if (containers.length === 1) {
      //     const container = new Container(containers[0])
      //     params.CONTAINER_UUID = container.uuid
      //     params.jobuuid = this.job ? this.job.uuid : ''
      //     params.category = 'LCL'
      //     params.ctx = new SeaExportJob(this.job)
      //     // TemplateSelectorWin.getInstance().showThisWin(job, "LCL", params, this);
      //   } else {
      //     params.CONTAINER_UUID = Array.from(containers, p => p.uuid)
      //     params.jobuuid = this.job ? this.job.uuid : ''
      //     params.category = 'CONTAINER_LIST'
      //     params.ctx = new SeaExportJob(this.job)
      //     // TemplateSelectorWin.getInstance().showThisWin(job, "CONTAINER_LIST", params, this);
      //   }
      //   return params
      // }
    },
    refreshLclSlaves() {
      // const lclSlaveUsageMap = {}
      // for (const container of this.containers) {
      //   // 处理小票装箱数据
      //   for (const containerUsage of container.containerUsage) {
      //     if (!lclSlaveUsageMap.hasOwnProperty(containerUsage.jobUuid)) {
      //       lclSlaveUsageMap[containerUsage.jobUuid] = []
      //     }
      //     const lclSlaveUsages = lclSlaveUsageMap[containerUsage.jobUuid]
      //     lclSlaveUsages.push(containerUsage)
      //   }
      // }
      // // 更新小票装箱信息
      // for (const slaves of this.lclSlaves) {
      //   slaves.containerUsages = lclSlaveUsageMap[slaves.uuid]
      // }
      // this.changeLclSlaves()
      // this.refreshContainerQwc()
      // this.refreshSalves()
      // this.left.gridApi.clearFocusedCell()
      // this.left.gridApi.refreshCells({ force: true })
      // this.right.gridApi.clearFocusedCell()
      // this.right.gridApi.refreshCells({ force: true })
      // this.gridApi.clearFocusedCell()
      // this.gridApi.refreshCells({ force: true })
    },
    // 查询未打托的货物明细
    upSearchNoPallet() {
      if (!this.upRowData || this.upRowData.length <= 0) {
        this.$message.warning('没有可以查询的数据。')
        return
      }
      // 操作符
      const containerNoOpt = this.up.containerNoOpt
      const cargoNameOpt = this.up.cargoNameOpt
      const shipmentIdOpt = this.up.shipmentIdOpt
      const referenceIdOpt = this.up.referenceIdOpt

      // 条件
      const containerNo = (this.up.containerNo && this.up.containerNo.trim()) ? this.up.containerNo.trim() : ''
      const cargoChineseName = (this.up.cargoName && this.up.cargoName.trim()) ? this.up.cargoName.trim() : ''
      const shipmentId = (this.up.shipmentId && this.up.shipmentId.trim()) ? this.up.shipmentId.trim() : ''
      const referenceId = (this.up.referenceId && this.up.referenceId.trim()) ? this.up.referenceId.trim() : ''

      const fhConditions = [] // 满足条件的集合
      for (const curRow of this.upRowData) {
        if (containerNo) {
          if (containerNoOpt === '=') { // 等于
            if (curRow.containerNo !== containerNo) {
              continue
            }
          } else if (containerNoOpt === '!=') { // 不等于
            if (curRow.containerNo === containerNo) {
              continue
            }
          } else if (containerNoOpt === 'LIKE') { // 包含
            if (curRow.containerNo.indexOf(containerNo) === -1) {
              continue
            }
          }
        }
        if (cargoChineseName) {
          if (cargoNameOpt === '=') { // 等于
            if (curRow.cargoChineseName !== cargoChineseName) {
              continue
            }
          } else if (cargoNameOpt === '!=') { // 不等于
            if (curRow.cargoChineseName === cargoChineseName) {
              continue
            }
          } else if (cargoNameOpt === 'LIKE') { // 包含
            if (curRow.cargoChineseName.indexOf(cargoChineseName) === -1) {
              continue
            }
          }
        }
        if (shipmentId) {
          if (shipmentIdOpt === '=') { // 等于
            if (curRow.shipmentId !== shipmentId) {
              continue
            }
          } else if (shipmentIdOpt === '!=') { // 不等于
            if (curRow.shipmentId === shipmentId) {
              continue
            }
          } else if (shipmentIdOpt === 'LIKE') { // 包含
            if (curRow.shipmentId.indexOf(shipmentId) === -1) {
              continue
            }
          }
        }
        if (referenceId) {
          if (referenceIdOpt === '=') { // 等于
            if (curRow.referenceId !== referenceId) {
              continue
            }
          } else if (referenceIdOpt === '!=') { // 不等于
            if (curRow.referenceId === referenceId) {
              continue
            }
          } else if (referenceIdOpt === 'LIKE') { // 包含
            if (curRow.referenceId.indexOf(referenceId) === -1) {
              continue
            }
          }
        }
        fhConditions.push(curRow)
      }
      this.gridApi.setRowData(fhConditions)
      this.gridApi.clearFocusedCell()
      this.gridApi.refreshCells({ force: true })
    },
    // 拣选
    upPick() {
      if (!this.upRowData || this.upRowData.length <= 0) {
        this.$message.warning('没有可以拣选的货物。')
        return
      }
      if (!this.up.upQuantity || this.up.upQuantity <= 0) {
        this.$message.warning('请输入拣选件数。')
        return
      }
      const nodes = this.gridOptions.api.getRenderedNodes()
      // 选中最后一行记录(用于 行 新增，删除)
      let index = 0
      for (const item of nodes) {
        index++
        item.setSelected(true)
        if (index > this.up.upQuantity) {
          item.setSelected(false)
        }
      }
    },
    // 根据中文名过滤托盘
    downSearchPallet() {
      if (!this.downLeftRowData || this.downLeftRowData.length <= 0) {
        this.$message.warning('没有可以查询的数据。')
        return
      }
      // 操作符
      const cargoNameOpt = 'LIKE'
      // 条件
      const cargoChineseName = (this.down.cargoName && this.down.cargoName.trim()) ? this.down.cargoName.trim() : ''
      const fhConditions = [] // 满足条件的集合
      for (const curRow of this.downLeftRowData) {
        if (cargoChineseName) {
          if (cargoNameOpt === '=') { // 等于
            if (curRow.cargoName !== cargoChineseName) {
              continue
            }
          } else if (cargoNameOpt === '!=') { // 不等于
            if (curRow.cargoName === cargoChineseName) {
              continue
            }
          } else if (cargoNameOpt === 'LIKE') { // 包含
            if (curRow.cargoName.indexOf(cargoChineseName) === -1) {
              continue
            }
          }
        }
        fhConditions.push(curRow)
      }
      this.left.gridApi.setRowData(fhConditions)
      this.left.gridApi.clearFocusedCell()
      this.left.gridApi.refreshCells({ force: true })
    },
    // 查询打托的货物明细
    downSearchCargoDetail() {
      if (!this.downRightRowData || this.downRightRowData.length <= 0) {
        this.$message.warning('没有可以查询的数据。')
        return
      }
      // 操作符
      const containerNoOpt = this.down.containerNoOpt
      // 条件
      const containerNo = (this.down.containerNo && this.down.containerNo.trim()) ? this.down.containerNo.trim() : ''

      const fhConditions = [] // 满足条件的集合
      for (const curRow of this.downRightRowData) {
        if (containerNo) {
          if (containerNoOpt === '=') { // 等于
            if (curRow.containerNo !== containerNo) {
              continue
            }
          } else if (containerNoOpt === '!=') { // 不等于
            if (curRow.containerNo === containerNo) {
              continue
            }
          } else if (containerNoOpt === 'LIKE') { // 包含
            if (curRow.containerNo.indexOf(containerNo) === -1) {
              continue
            }
          }
        }
        fhConditions.push(curRow)
      }
      this.right.gridApi.setRowData(fhConditions)
      this.right.gridApi.clearFocusedCell()
      this.right.gridApi.refreshCells({ force: true })
    },
    // 添加托盘
    addPallet() {
      if (!this.downLeftRowData || this.downLeftRowData.length <= 0) {
        this.downLeftRowData = []
      }
      const pallet = new FbaPallet().fillDefaultValue().getData()
      pallet.warehouseInUuid = this.warehouseIn.uuid
      pallet.id = this.left.uuidPrefixRule + getUuid() // 删除时用来匹配
      pallet.isDirty = true
      this.downLeftRowData.push(pallet)
      // if (!this.warehouseIn.fbaPallets) this.warehouseIn.fbaPallets = []
      // this.warehouseIn.fbaPallets.push(pallet)
      // 默认选中新增行
      this.$nextTick(() => {
        this.setGridSelectPallet(pallet)
        this.calcPallets()
      })
    },
    // 删除托盘
    removePallet() {
      const chooseRows = this.left.gridApi.getSelectedRows()
      if (!chooseRows || chooseRows.length <= 0) {
        this.$message.warning('请选中要删除的托盘。')
        return
      }
      for (const pallet of chooseRows) {
        if (pallet && pallet.status && Number(pallet.status) === 1) { // 已出库不能删除
          this.$message.warning('已出库的托盘不能删除，请检查。')
          return
        }
      }
      this.$confirm('删除后将解除托盘与托盘内货物的绑定关系，是否确认？', this.$t('common.tips.prompt'), {
        confirmButtonText: this.$t('common.btn.ok'),
        cancelButtonText: this.$t('common.btn.cancel'),
        type: 'warning'
      }).then(() => {
        const pallets = this.downLeftRowData
        for (const pallet of chooseRows) {
          pallet.deleted = true
          pallet.warehouseInUuid = null

          // 移除托盘之前先把货物明细移除
          if (pallet.warehouseInDetailList && pallet.warehouseInDetailList.length > 0) {
            for (const detail of pallet.warehouseInDetailList) {
              detail.palletNo = null
              detail.palletUuid = null
              if (pallet.uuid) { // 数据库需要移除托盘关系的货物信息
                this.removeCargoDetails.push(detail)
              }
            }
          }
          const index = pallets.indexOf(pallet)
          if (index >= 0) {
            pallets.splice(index, 1)
          }
          if (pallet.uuid) { // 数据库需要删除的托盘
            this.delFbaPalletKeys.push(pallet.uuid)
          }
          if (this.warehouseIn.fbaPallets && this.warehouseIn.fbaPallets > 0) {
            for (const fbaPallet of this.warehouseIn.fbaPallets) {
              // 删除时匹配id或者uuid
              if (pallet.id === fbaPallet.id || pallet.uuid === fbaPallet.uuid) {
                const pIndex = this.warehouseIn.fbaPallets.indexOf(pallet)
                if (pIndex > -1) {
                  this.warehouseIn.fbaPallets.splice(pIndex, 1)
                }
              }
            }
          }
          // 默认选中新增行
          this.$nextTick(() => {
            this.setGridSelectPallet(pallet)
            this.calcPallets()
          })
        }
      }).catch(() => {
      })
    },
    // 打托
    addToPalletHandler() {
      if (this.warehouseIn.updateCargoDetail) { // 对基本页签的货物明细做过 新增，删除，编辑 则不允许进行打托以及取消打托
        this.$message.warning('货物信息被更改，请先保存再进行打托操作。')
        return
      }
      if (!this.selectedPallet) {
        this.$message.warning('请选中托盘。')
        return
      }
      if (this.selectedPallet && this.selectedPallet.status && Number(this.selectedPallet.status) === 1) {
        this.$message.warning('当前托盘已出库,不能打托')
        return
      }
      const chooseRows = this.gridApi.getSelectedRows()
      if (!chooseRows || chooseRows.length <= 0) {
        this.$message.warning('请选择要打托的货物。')
        return
      }
      if (!this.downRightRowData) {
        this.downRightRowData = []
      }
      const cargoNames = this.selectedPallet.cargoName ? this.selectedPallet.cargoName.split(',') : []
      for (const chooseRow of chooseRows) {
        chooseRow.dirty = true
        chooseRow.palletUuid = this.selectedPallet.uuid ? this.selectedPallet.uuid : 'tmpUuid'

        // 这里将取消打托的货物再次打托时，需要将之前移除的去掉
        if (this.removeCargoDetails && this.removeCargoDetails.length > 0) {
          for (const curRemove of this.removeCargoDetails) {
            if (chooseRow.uuid !== curRemove.uuid) continue
            const pIndex = this.removeCargoDetails.indexOf(curRemove)
            if (pIndex > -1) {
              this.removeCargoDetails.splice(pIndex, 1)
            }
          }
        }

        if (!cargoNames.includes(chooseRow.cargoChineseName)) {
          cargoNames.push(chooseRow.cargoChineseName)
        }
        this.downRightRowData.push(chooseRow)
      }
      this.selectedPallet.isDirty = true
      this.selectedPallet.warehouseInDetailList = this.downRightRowData
      this.selectedPallet.boxesNumber = this.downRightRowData.length
      this.selectedPallet.cargoName = cargoNames.join(',')
      this.calcUpSumJmt()
      this.calcDownSumJmt()
      this.$nextTick(() => {
        this.gridApi.setRowData(this.upRowData)
        this.gridApi.refreshCells({ force: true })
        this.right.gridApi.setRowData(this.downRightRowData)
        this.right.gridApi.clearFocusedCell()
        this.right.gridApi.refreshCells({ force: true })
        this.left.gridApi.refreshCells({ force: true })
      })
    },
    // 取消打托
    removeToPalletHandler() {
      if (this.warehouseIn.updateCargoDetail) {
        this.$message.warning('货物信息被更改，请先保存再进行打托操作。')
        return
      }
      const chooseRows = this.right.gridApi.getSelectedRows()
      if (!chooseRows || chooseRows.length <= 0) {
        this.$message.warning('请选择要取消打托的货物。')
        return
      }
      if (this.selectedPallet && this.selectedPallet.status && Number(this.selectedPallet.status) === 1) {
        this.$message.warning('当前托盘已出库,不能取消打托')
        return
      }
      for (const chooseRow of chooseRows) {
        if (chooseRow.palletUuid) { // 如果原来就有托盘的话，移除的时候记一下
          this.removeCargoDetails.push(chooseRow)
        }
        chooseRow.dirty = true
        chooseRow.palletUuid = ''
        chooseRow.palletNo = ''
        if (this.downRightRowData && this.downRightRowData.length > 0) {
          for (const cur of this.downRightRowData) {
            if (cur.uuid === chooseRow.uuid) {
              const index = this.downRightRowData.indexOf(cur)
              if (index >= 0) {
                this.downRightRowData.splice(index, 1)
              }
            }
          }
        }
      }
      this.selectedPallet.warehouseInDetailList = this.downRightRowData
      this.selectedPallet.boxesNumber = this.downRightRowData.length
      // 品名
      const cargoNames = []
      for (const chooseRow of this.downRightRowData) {
        if (!cargoNames.includes(chooseRow.cargoChineseName)) {
          cargoNames.push(chooseRow.cargoChineseName)
        }
      }
      this.selectedPallet.cargoName = cargoNames.join(',')
      this.calcUpSumJmt()
      this.calcDownSumJmt()
      this.$nextTick(() => {
        this.$nextTick(() => {
          this.gridApi.setRowData(this.upRowData)
          this.gridApi.refreshCells({ force: true })
          this.right.gridApi.setRowData(this.downRightRowData)
          this.right.gridApi.clearFocusedCell()
          this.right.gridApi.refreshCells({ force: true })
          this.left.gridApi.refreshCells({ force: true })
        })
      })
    },
    // EXCEL导入
    handleProgress() {
      this.loading = getLoading()
    },
    // EXCEL导入成功
    handleSuccess(response, file, fileList) {
      if (this.loading) this.loading.close()
      const res = response.data
      if (res.success) {
        this.$message.success(res.message)
        this.$emit('success', true)
      } else {
        this.$alert(res.message, this.$t('common.tips.prompt'), {
          dangerouslyUseHTMLString: true,
          showClose: false,
          confirmButtonText: this.$t('common.btn.close'),
          type: 'warning'
        })
      }
    },
    // EXCEL导入失败
    handleError(error) {
      const errorData = JSON.parse(error.message)
      this.$message.error({ 'message': errorData.message, 'duration': 15000 })
      if (this.loading) this.loading.close()
    },
    // 模板下载
    downLoad() {
      ExportUtils.downloadTemplateFile('ImportPalletTemplate.xlsx', 'fba')
    },
    // 默认选中第一行托盘信息
    setGridSelectPallet(selectLastRow) {
      const nodes = this.left.gridOptions.api.getRenderedNodes()
      // 选中最后一行记录(用于 行 新增，删除)
      if (selectLastRow) {
        let index = 0
        for (const item of nodes) {
          if (index === nodes.length - 1) {
            item.setSelected(true)
            this.selectedPallet = item.data
          }
          index++
        }
      } else {
        // 默认选中第一个
        for (const item of nodes) {
          if (!item) continue
          item.setSelected(true)
          this.selectedPallet = item.data
          break
        }
      }
    },
    // 计算未打托件毛体
    calcUpSumJmt() {
      let quantitySum = 0
      let weightSum = 0
      let cubageSum = 0
      if (this.upRowData && this.upRowData.length > 0) {
        for (const item of this.upRowData) {
          if (item.quantity) {
            quantitySum += Number(item.quantity)
          }
          if (item.singleBoxWeight) {
            weightSum += Number(item.singleBoxWeight)
          }
          if (item.boxLength && item.boxWidth && item.boxHeight) {
            const tempCubage = Number(item.boxLength) * Number(item.boxWidth) * Number(item.boxHeight)
            cubageSum += (tempCubage || 0)
          }
        }
      }
      this.up.totalQuantity = quantitySum
      this.up.totalWeight = NumberUtils.ToFixed2(weightSum, 2)
      this.up.totalCubage = NumberUtils.ToFixed2(cubageSum / 1000000, 3)
    },
    // 计算当前托盘信息已打托件毛体
    calcDownSumJmt() {
      let quantitySum = 0
      let weightSum = 0
      let cubageSum = 0
      if (this.downRightRowData && this.downRightRowData.length > 0) {
        for (const item of this.downRightRowData) {
          if (item.quantity) {
            quantitySum += Number(item.quantity)
          }
          if (item.singleBoxWeight) {
            weightSum += Number(item.singleBoxWeight)
          }
          if (item.boxLength && item.boxWidth && item.boxHeight) {
            const tempCubage = Number(item.boxLength) * Number(item.boxWidth) * Number(item.boxHeight)
            cubageSum += (tempCubage || 0)
          }
        }
      }
      this.down.totalQuantity = quantitySum
      this.down.totalWeight = NumberUtils.ToFixed2(weightSum, 2)
      this.down.totalCubage = NumberUtils.ToFixed2(cubageSum / 1000000, 3)
    },
    // 托盘信息是否可以编辑
    isEditPallet(params) {
      const pallet = params.data
      if (pallet && pallet.status && Number(pallet.status) === 1) { // 已出库不能编辑
        return false
      }
      return true
    }
  }
}
</script>

<style lang="scss" scoped>
</style>
